/** Login redirects stay inside this app and preserve the requested record/tab. */
export function internalLoginRedirect(value: unknown): string | null {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')
    && !/[\\\r\n]/.test(value) ? value : null;
}

export function esiLoginHref(appBase: string, currentRoute: string): string {
  return '/_esi/login?next=' + encodeURIComponent(esiReturnPath(appBase, currentRoute));
}

export function esiReturnPath(appBase: string, currentRoute: string): string {
  const route = internalLoginRedirect(currentRoute) ?? '/login';
  const base = appBase.endsWith('/') ? appBase : appBase + '/';
  return base + route.slice(1);
}

/** Official scan/OAuth fallback goes straight back to DS without the portal page. */
export function wecomStartHref(appBase: string, currentRoute: string): string {
  return '/_esi/wecom/start?next=' + encodeURIComponent(esiReturnPath(appBase, currentRoute));
}
